export default __webpack_public_path__ + "static/media/vertical5.f88223b6.JPG";